import './content-message.scss';

type ContentMessageProps = {
  message: JSX.Element | string;
};

export function ContentMessage({ message }: ContentMessageProps) {
  return (
    <div className="content-message">
      <div className="content-message__content">
        <p>{message}</p>
      </div>
    </div>
  );
}
